@if(loading){<lib-spinner-overlay></lib-spinner-overlay>}

<lib-dba-mat-table tableNameId="service" [data]="sicherungssystemList" [columnsdef]="columnsdefMain" [importButton]="false"
    [editButton]="permissionService.serviceSchreiben" [createButton]="permissionService.serviceSchreiben"
    [deleteButton]="permissionService.serviceLoeschen" [dynamicSize]="true" [(selectedElement)]="selectedSicherungssystem"
    (openDialog2)="OpenDialog($event)" (deleteClicked)="deleteData($event[0].SicherungssystemID!)">

     <lib-dba-mat-table-select [filter]="debitorFilter" [label]="language.debitor | translationPipe"
        labelProperty="Name" [list]="debitorList" [(value)]="selectedDebitor" [translate]="false"
        (valueChange)="filterStandort()">
    </lib-dba-mat-table-select>

    <lib-dba-mat-table-select [filter]="standortFilter" [label]="language.Standort| translationPipe"
        labelProperty="Bezeichnung" [list]="standortfilteredList" [(value)]="selectedStandort" [translate]="false"
        (valueChange)="filterObjekte()">
    </lib-dba-mat-table-select>

    <lib-dba-mat-table-select [filter]="objektFilter" [label]="language.objekt | translationPipe"
        labelProperty="Bezeichnung" [list]="objektfilteredList" [(value)]="selectedObjekt" 
        (valueChange)="filterroofarea()"
        [translate]="false">
    </lib-dba-mat-table-select>
 
    <lib-dba-mat-table-select [filter]="roofareaFilter" [label]="language.roofarea | translationPipe" labelProperty="Bezeichnung"
        [list]="roofareaFilteredList" [(value)]="selectedRoofarea!"  [translate]="false">
    </lib-dba-mat-table-select>        
</lib-dba-mat-table>